import { pxArrayToRem, pxToRem } from '@archipro-design/aria';
import type { StyleRule } from '@archipro-design/aria';
import { hex2rgba } from '~/utils/colorHelper';

export const ColorOption: StyleRule = ({ theme }) => ({
    minHeight: pxToRem(147),
    position: 'relative',
    padding: pxArrayToRem([12, 0]),
    margin: pxArrayToRem([0, 12]),
    fontSize: pxToRem(12),
    letterSpacing: '0.08em',
    lineHeight: '125%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    color: theme.siteVariables.colors.charcoal[250],
    ...theme.siteVariables.textStyles.Text.Roman55,
    '&[aria-selected="true"]': {
        ...theme.siteVariables.textStyles.Text.Medium65,
    },
    '& label': {
        textAlign: 'center',
        cursor: 'inherit',
        marginTop: theme.siteVariables.spaces['space-16'],
        maxWidth: pxToRem(132),
        '-webkit-hyphens': 'auto',
        hyphens: 'auto',
        overflowWrap: 'break-word',
        textTransform: 'uppercase',
    },
    '&:last-child': {
        marginRight: pxToRem(24),
    },
    [theme.screen.min.tablet]: {
        padding: pxArrayToRem([12, 0]),
        margin: 0,
        '&:last-child': {
            marginRight: 0,
        },
        '&:hover': {
            backgroundColor: hex2rgba(
                theme.siteVariables.colors.primitive.black,
                0.06,
            ),
        },
    },
});

export const CheckMark: StyleRule = ({ theme }) => ({
    position: 'absolute',
    right: pxToRem(12),
    top: pxToRem(12),
    padding: pxToRem(4),
    backgroundColor: theme.siteVariables.colors.charcoal['250'],
    borderRadius: '50%',
    '& svg': {
        width: pxToRem(24),
        height: pxToRem(24),
        fill: theme.siteVariables.colors.white['000'],
    },
});
